<template>
  <div class="card">
    <div class="card-content">
      <div class="content">
        <strong v-bind:class="markedClass">{{ glossaryAndConceptItem.fields.name }}</strong>
        <hr>
        <markdown>{{ glossaryAndConceptItem.fields.description }}</markdown>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: [
      'glossaryAndConceptItem',
      'marked'
    ],
    computed: {
      markedClass () {
        /* Return classes */
        return (this.marked) ? 'has-background-warning' : ''
      }
    }
  }
</script>

<style>
  .card {
    width: 100%;
  }
  hr {
    margin: 0.5rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/General/GlossaryAndConceptCard.vue